import { render, staticRenderFns } from "./CdbCustomerTourList.vue?vue&type=template&id=f4e584ea&scoped=true&"
import script from "./CdbCustomerTourList.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerTourList.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerTourList.vue?vue&type=style&index=0&id=f4e584ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e584ea",
  null
  
)

export default component.exports